import React, { FC, KeyboardEvent, memo } from "react";
import { Controller } from "react-hook-form/dist/index.ie11";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import s from "./TextArea.less";
import { TAling } from "~/shared/ui/Fields/Input";

interface IProps {
  label?: string;
  name: string;
  error?: string;
  placeholder?: string;
  control;
  disabled?: boolean;
  vertical?: boolean;
  newStyle?: boolean;
  required?: boolean;
  customClassName?: string;
  type?: string;
  defaultValue?: string;
  labelAlign?: TAling;
  onEnterKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  fullWidth?: boolean;
}

const TextArea: FC<IProps> = ({
  label,
  name,
  control,
  error,
  placeholder = "",
  defaultValue,
  disabled = false,
  vertical = false,
  newStyle = false,
  required = false,
  customClassName = "",
  labelAlign,
  onEnterKeyDown,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const align = { textAlign: labelAlign };

  const keyDownDecorator = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter") onEnterKeyDown(e);
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ value, onChange, ...props }) => (
        <div
          className={clsx({
            [s.s_text_area]: true,
            [s.text_area_vertical]: vertical,
            [s.text_area_newStyle]: newStyle,
            [s.fullWidth]: fullWidth,
            [customClassName]: true,
          })}
        >
          {label && <label style={align}>{label}</label>}
          <div className={s.desc}>
            <textarea
              {...props}
              name={name}
              value={value}
              onChange={onChange}
              disabled={disabled}
              required={required}
              placeholder={placeholder}
              onKeyDown={keyDownDecorator}
            />
            {error && <span className={s.error_text}>{error}</span>}
          </div>
        </div>
      )}
    />
  );
};
export default memo(TextArea);
